import {TabsProps} from "antd";
import React, {useEffect, useState} from "react";
import PatientList from "./PatientList/PatientList";
import DetailInfo from "./DetailInfo/DetailInfo";
import {HeaderPage, Tabs} from "components/common";
import "./Analysis.scss";
import HistoryTab from "./HistoryTab/HistoryTab";
import {tabKeys} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import ListConfiguration from "./ListConfiguration/ListConfiguration";
import {
  setActiveKey,
  setButtonsHeader,
  setSiderKey,
} from "redux/reducer/common";
import {HistoryExamine} from "components/common";
import ParaclinicalTest from "./ParaclinicalTest/ParaclinicalTest";
import ReportWaittingAnalysis from "./ReportWaittingAnalysis/ReportWaittingAnalysis";

const itemsInit: TabsProps["items"] = [
  {
    key: tabKeys.ANALYSIS.LIST_PATIENT_ANALYSIS,
    label: "Danh sách bệnh nhân",
    children: <PatientList />,
  },
  {
    key: tabKeys.ANALYSIS.DETAIL_PATIENT_ANALYSIS,
    label: "Chi tiết thông tin",
    children: <DetailInfo />,
    // disabled: isDisabled,
  },
  {
    key: tabKeys.ANALYSIS.HISTORY_ANALYSIS,
    label: "Lịch sử khám bệnh",
    children: <HistoryExamine />,
  },
  {
    key: tabKeys.ANALYSIS.CATEGORY_ANALYSIS,
    label: "Cấu hình danh mục xét nghiệm",
    children: <ListConfiguration />,
  },
  {
    key: tabKeys.ANALYSIS.BOOK_ANALYSIS,
    label: "Sổ xét nghiệm cận lâm sàng",
    children: <ParaclinicalTest />,
  },
  {
    key: tabKeys.ANALYSIS.REPORT_WAITTING_ANALYSIS,
    label: "Báo cáo thống kê thời gian xét nghiệm",
    children: <ReportWaittingAnalysis />,
  },
];

const Analysis: React.FC = () => {
  document.title = "Xét nghiệm";
  const [isDisabled, setIsDisabled] = useState(true);
  const dispatch = useAppDispatch();
  const activeKey = useAppSelector(state => state.common.activeTab);
  const [items, setItems] = useState<TabsProps["items"]>(itemsInit);
  const idXN = useAppSelector(state => state.reduxCommon.idXetNghiem);

  useEffect(() => {
    itemsInit[1].disabled = idXN == null;
    itemsInit[2].disabled = idXN == null;
    setItems([...itemsInit]);
  }, [idXN]);

  useEffect(() => {
    // dispatch(setActiveKey(tabKeys.ANALYSIS.LIST_PATIENT_ANALYSIS))
    dispatch(setSiderKey("xetNghiem"));
    // dispatch(setButtonsHeader([]));
  }, []);

  useEffect(() => {
    if (activeKey !== tabKeys.ANALYSIS.DETAIL_PATIENT_ANALYSIS) {
      dispatch(setButtonsHeader([]));
    }
  }, [activeKey]);

  return (
    <div className="analysis page">
      <div className="main">
        <Tabs activeKey={activeKey} items={items} />
      </div>
    </div>
  );
};

export default Analysis;
